<template>
<footer class="mb-footer">
  <div class="mb-footer__inner">
    <div class="mb-footer__intro">
      <img src="@/assets/myvpnbook-logo.svg" alt="" width="38" height="38">
      <p>
        <router-link class="mb-footer__brand-link" to="/" title="MyVPNBook">
          <strong>MyVPNBook</strong>
        </router-link>
        is a free VPN information website providing setup guides, server information, troubleshooting tips, and
        online privacy resources.
      </p>
    </div>

    <div class="mb-footer__links-group">
      <nav class="mb-footer__links" aria-label="Legal">
        <router-link to="/privacy-policy/">Privacy Policy</router-link>
        <router-link to="/terms/">Terms of Service</router-link>
        <router-link to="/cookie-policy/">Cookie Policy</router-link>
        <router-link to="/dmca/">DMCA</router-link>
        <router-link to="/disclaimer/">Disclaimer</router-link>
      </nav>
    </div>

    <p class="mb-footer__copyright">
      &copy; {{ year }} MyVPNBook. All Rights Reserved. MyVPNBook is not affiliated with any third-party VPN
      provider unless otherwise stated.
    </p>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
.mb-footer {
  background: #f8fafc;
  border-top: 1px solid #e8eef6;
  color: #4b5563;
  padding: 18px 20px 20px;
}

.mb-footer__inner {
  width: var(--vpn-content-width);
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
}

.mb-footer__intro {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 1060px;
  margin: 0 auto;
}

.mb-footer__intro img {
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
}

.mb-footer__intro p {
  margin: 0;
  color: #4b5563;
  font-size: 12px;
  line-height: 1.45;
}

.mb-footer__intro strong {
  color: #111827;
  font-weight: 800;
}

.mb-footer__brand-link {
  color: #4b5563;
  text-decoration: none;
}

.mb-footer__brand-link strong {
  color: inherit;
  font-weight: 700;
}

.mb-footer__brand-link:hover {
  color: var(--vpn-brand);
}

.mb-footer__links-group {
  margin-top: 12px;
}

.mb-footer__links {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.mb-footer__links a {
  padding: 0 13px;
  border-left: 1px solid #d6dee9;
  color: #4b5563;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 700;
  text-decoration: none;
}

.mb-footer__links a:first-child {
  border-left: 0;
}

.mb-footer__links a:hover {
  color: var(--vpn-brand);
}

.mb-footer__copyright {
  margin: 10px auto 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.5;
}

@media (max-width: 760px) {
  .mb-footer {
    padding: 16px 20px 18px;
  }

  .mb-footer__intro {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .mb-footer__intro p {
    flex: 1 1 100%;
    font-size: 12px;
  }

  .mb-footer__links {
    row-gap: 2px;
  }

  .mb-footer__links a {
    padding: 2px 10px;
    font-size: 12px;
  }

  .mb-footer__copyright {
    font-size: 11px;
  }
}
</style>
